import { render, staticRenderFns } from "./Index4.vue?vue&type=template&id=1d240347"
import script from "./Index4.vue?vue&type=script&lang=js"
export * from "./Index4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports